// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const EquipmentsList = lazy(() => import('../../views/equipments/list'))

const Equipments = [
  {
    path: '/equipments/list',
    element: <EquipmentsList />
  }
]

export default Equipments
